

import { NgModule } from '@angular/core';

import { PagesComponent } from './pages.component';
import { PagesRoutingModule } from './pages-routing.module';
import { ThemeModule } from '../@theme/theme.module';
import { MiscellaneousModule } from './miscellaneous/miscellaneous.module';
import { PagesMenu } from './pages-menu';
import { NbChatModule, NbMenuModule } from '@nebular/theme';
import { AuthModule } from '../@auth/auth.module';
import { ECommerceModule } from './e-commerce/e-commerce.module';
import { InviteComponent } from './miscellaneous/invite/invite.component';
import { InviteProviderComponent } from './invite-provider/invite-provider.component';

import {
    NbActionsModule,
    NbButtonModule,
    NbCardModule,
    NbInputModule,
    NbTabsetModule,
    NbUserModule,
    NbRadioModule,
    NbSelectModule,
    NbListModule,
    NbIconModule,
    NbSpinnerModule,
    NbDatepickerModule,
    NbToggleModule,
    NbFormFieldModule,
} from '@nebular/theme';
import { ComponentsModule } from '../@components/components.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChatModule } from './chat/chat.module';

const NB_MODULES = [
    NbActionsModule,
    NbButtonModule,
    NbCardModule,
    NbInputModule,
    NbTabsetModule,
    NbUserModule,
    NbRadioModule,
    NbSelectModule,
    NbListModule,
    NbIconModule,
    NbSpinnerModule,
    NbDatepickerModule,
    NbInputModule,
    NbToggleModule,
    NbFormFieldModule,
];

const PAGES_COMPONENTS = [
    PagesComponent,    
    InviteComponent,
    InviteProviderComponent
];

@NgModule({
    imports: [
        ComponentsModule,
        PagesRoutingModule,
        ThemeModule,
        ECommerceModule,
        NbMenuModule,
        MiscellaneousModule,
        FormsModule,
        ReactiveFormsModule,
        ...NB_MODULES,
        AuthModule.forRoot(),
        ChatModule        
    ],
    declarations: [
        ...PAGES_COMPONENTS
    ],
    providers: [
        PagesMenu
    ],
})
export class PagesModule {
}
